<div class="regular-hours__container">
  <div class="regular-hours__container__day">
    <span>{{ dayDisplayNameKey(dayOfWeek) | translate }}</span>
  </div>
  <div class="regular-hours__container__times" *ngIf="hours.length === 0">
    <span class="regular-hours__container__time-span">
      {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSED' | translate }}
    </span>
  </div>
  <div class="regular-hours__container__times" *ngIf="hours.length > 0">
    <span *ngFor="let period of hours" class="regular-hours__container__time-span">
      <span *ngIf="is24Hour(period) && hasTime(period)">
        {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.ALL_DAY' | translate }}
      </span>
      <span *ngIf="!is24Hour(period) && hasTime(period)">
        <span class="time-span__opens">{{ displayTime(period.openTime) }}</span>
        <span class="time-span__divider">&nbsp;&#8212;&nbsp;</span>
        <span class="time-span__closes">{{ displayTime(period.closeTime) }}</span>
      </span>
    </span>
  </div>
</div>
